import { Injectable } from '@angular/core';

import { UniversalStorageService } from '../../../base/services/universal-storage.service';

@Injectable({
    providedIn: 'root',
})
export class RenewStorageService extends UniversalStorageService {
    public KEY: { [index: string]: any } = {
        GALLIUM_DATA: 'galliumData',
        GALLIUM_STATUS: 'galliumStatus',
        GALLIUM_STATUS_KO: 'KO',
        CONTRACTS_INFOS: 'contracts_infos',
        CUSTOMER_PHONE_ID: 'customer_phone_id',
        FILTRED_GALLIUM_DATA: 'FiltredGalliumData',
    };
    public LS_KEY: { [index: string]: any } = {
        GALLIUM_PRICES: 'galliumPrices',
    };

    protected sessionStorageKeys: string[] = Object.values(this.KEY);
    protected localStorageKeys: string[] = Object.values(this.LS_KEY);
}
